/**
 * Re-alpha a palette colour.
 *
 * Tints are how identity survives the depth budget: a level-2 well cannot carry
 * a border, so an agent, a metric or an analysis row expresses its hue as a low
 * -opacity fill of its own token instead. Doing that by hand at the call site
 * means hand-writing `hsla()`, which the design-system check rejects outside
 * `theme/` — and rightly so. This is the sanctioned way.
 *
 * Non-HSL inputs are returned unchanged rather than silently mangled.
 */
export function withAlpha(color: string, alpha: number): string {
  if (color.startsWith('hsla(')) {
    return color.replace(/,\s*[\d.]+\)$/, `, ${alpha})`);
  }
  if (color.startsWith('hsl(')) {
    return color.replace('hsl(', 'hsla(').replace(')', `, ${alpha})`);
  }
  return color;
}
